<p-blockUI [blocked]="(isLoading | async) ?? false">
  <div class="d-flex justify-content-center align-items-center vh-100">
    <p-progressSpinner
      [fill]="fill"
      [animationDuration]="animationDuration"
      [strokeWidth]="strokeWidth"
      styleClass="custom-spinner"></p-progressSpinner>
  </div>
</p-blockUI>
